// IELTS Mock 9 — Listening (IELTS Fever Listening Practice Test 51)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Groups with `optionsBox` show a text box of lettered options instead of an image.
// The `chooseTwo` group (Questions 21–23) shares one option list across three
// question numbers; answers may be given in any order.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening9.mp3";

const IELTS_MOCK9_LISTENING = {
  title: "IELTS Listening Mock 9",
  sections: [
    {
      id: "s1",
      title: "Section 1: Booking a Hotel for a Group Visit",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 1–6: Which hotels have the following facilities? Write the correct letter, A, B, C or D, next to Questions 1–6.",
          example: { q: "Online booking", answer: "B" },
          image: null,
          optionsBox: ["A. Royal Hotel", "B. Star Hotel", "C. Winchester Hotel", "D. All three hotels"],
          mapOptions: ["A", "B", "C", "D"],
          questions: [
            { id: "q1", text: "Sea view", type: "map", answer: "B" },
            { id: "q2", text: "Handicap accessibility", type: "map", answer: "D" },
            { id: "q3", text: "Multiple meal options", type: "map", answer: "A" },
            { id: "q4", text: "Private dining", type: "map", answer: "A" },
            { id: "q5", text: "Group discount", type: "map", answer: "C" },
            { id: "q6", text: "Children's play area", type: "map", answer: "C" },
          ],
        },
        {
          instruction: "Questions 7–10: Complete the sentences below. Write ONE WORD ONLY for each answer.",
          image: null,
          questions: [
            { id: "q7", text: "The man needs to send his ______ to the hotel.", type: "fill_blank", answer: ["deposit"] },
            { id: "q8", text: "He also needs to make ______ immediately.", type: "fill_blank", answer: ["invitations"] },
            { id: "q9", text: "The hotel must be alerted in advance if guests will need help with ______.", type: "fill_blank", answer: ["transport", "transportation"] },
            { id: "q10", text: "There is no need to prepare ______ for hotel drivers.", type: "fill_blank", answer: ["gifts", "presents"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: The Durham Country Car Show",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 11–16: Complete the form below. Write NO MORE THAN TWO WORDS AND/OR A NUMBER for each answer.",
          heading: "Durham Country Car Show",
          image: null,
          questions: [
            { id: "q11", text: "Public grand opening date: ______", type: "fill_blank", answer: ["19 March", "19th March", "March 19", "March 19th"] },
            { id: "q12", text: "Number of viewers: ______", type: "fill_blank", answer: ["70,000", "70000", "70 000"] },
            { id: "q13", text: "Off-peak day price: £10 for adults, £______ for children", type: "fill_blank", answer: ["5"] },
            { id: "q14", text: "Best day to visit: ______", type: "fill_blank", answer: ["Sunday"] },
            { id: "q15", text: "New car category: ______", type: "fill_blank", answer: ["electricity", "electric"] },
            { id: "q16", text: "Entertainment: ______", type: "fill_blank", answer: ["racing car", "racing cars"] },
          ],
        },
        {
          instruction:
            "Questions 17–20: When were the following features included in the auto show? Write the correct letter, A, B or C, next to Questions 17–20.",
          image: null,
          optionsBox: ["A. Last year", "B. This year", "C. Both"],
          mapOptions: ["A", "B", "C"],
          questions: [
            { id: "q17", text: "Higher number of seats", type: "map", answer: "B" },
            { id: "q18", text: "Fun for children", type: "map", answer: "C" },
            { id: "q19", text: "4x4 test drive", type: "map", answer: "C" },
            { id: "q20", text: "Lucky draw for a car", type: "map", answer: "A" },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Choosing Courses for Next Semester",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 21–23: Choose THREE letters, A–G.",
          chooseTwo: true,
          question: "Which THREE factors should the student consider while selecting courses?",
          options: [
            "A. class time",
            "B. course topic",
            "C. amount of homework",
            "D. ease of course",
            "E. relevance to future career",
            "F. course structure",
            "G. professor's reputation",
          ],
          answer: ["B", "E", "F"],
          questions: [{ id: "q21" }, { id: "q22" }, { id: "q23" }],
        },
        {
          instruction: "Questions 24–27: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q24",
              text: "The tutor recommends against taking Human Physiology because it would not be the best",
              type: "mcq",
              options: ["A. time management.", "B. chance at earning an A.", "C. topic for a research paper."],
              answer: "A",
            },
            {
              id: "q25",
              text: "The student decides to do a dissertation because",
              type: "mcq",
              options: [
                "A. he takes it to boost his GPA.",
                "B. he likes to develop more supportive details.",
                "C. he wants to conduct more interviews.",
              ],
              answer: "B",
            },
            {
              id: "q26",
              text: "The student thought the research paper was",
              type: "mcq",
              options: ["A. already completed.", "B. worth finishing.", "C. too complicated."],
              answer: "C",
            },
            {
              id: "q27",
              text: "The method of data collection was",
              type: "mcq",
              options: ["A. interviews.", "B. lab studies.", "C. questionnaires."],
              answer: "A",
            },
          ],
        },
        {
          instruction: "Questions 28–30: Complete the sentences below. Write ONE WORD ONLY for each answer.",
          image: null,
          questions: [
            { id: "q28", text: "The first draft should be finished by the end of ______.", type: "fill_blank", answer: ["March"] },
            { id: "q29", text: "The dissertation should be registered with the ______ in the Department Office.", type: "fill_blank", answer: ["secretary"] },
            { id: "q30", text: "The student can get the relevant database from the ______ office.", type: "fill_blank", answer: ["computer"] },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: The Role of Sleep in Humans and Animals",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 31–40: Complete the notes below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "The role of sleep in humans and animals",
          image: null,
          questions: [
            { id: "q31", text: "Compared to those without food, animals without sleep are more likely to suffer from ______.", type: "fill_blank", answer: ["attack", "attacks"] },
            { id: "q32", text: "Sleep is necessary for all animals, whether they are reptiles, ______ or fish.", type: "fill_blank", answer: ["mammals"] },
            { id: "q33", text: "Dolphins swim to the surface when sleeping, because they need to ______.", type: "fill_blank", answer: ["breathe"] },
            { id: "q34", text: "Birds are constantly ______ in the presence of numerous predators.", type: "fill_blank", answer: ["on edge"] },
            { id: "q35", text: "Lying in one position for a long time could injure a horse, because their ______ are delicate.", type: "fill_blank", answer: ["bones"] },
            { id: "q36", text: "Animals can also have ______, the same as humans.", type: "fill_blank", answer: ["sleeping problems", "sleep problems"] },
            { id: "q37", text: "Sleep helps us to organise our ______ of the day.", type: "fill_blank", answer: ["memories"] },
            { id: "q38", text: "Sleep plays a key role in ______.", type: "fill_blank", answer: ["learning"] },
            { id: "q39", text: "Because their sleeping pattern is similar to humans', ______ are studied to increase our knowledge of human physiology.", type: "fill_blank", answer: ["rats"] },
            { id: "q40", text: "Scientists study the ______ of the fruit fly to understand the function of human genes.", type: "fill_blank", answer: ["genetic structure"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK9_LISTENING;
